import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { linksRouter } from "../../../config/RouterLink";

/**Ant-design icons */
import { InfoCircleFilled } from "@ant-design/icons";

/**Ant-design*/
import { Col, Row } from "antd";

/**Redux-Ducks */
import {
  obtenerSistemaINE,
  obtenerSistemaOPLE,
} from "../../../redux/consultavacantes/sistemasDucks";

/**Utils */
/* import * as uiText from "../../../utils"; */

/**Estilos CSS */
import "../../../assets/css/Cvacantes.css";
import { Link } from "react-router-dom";
import "./HeaderVacantes.css";
import moment from "moment-timezone";
import { DATE_FORMAT_EXP } from "../../../utils";

export const HeaderVacantes = () => {
  const { autenticado } = useSelector((state) => state.usuarioLogin);
  const { idSistema } = useSelector((state) => state.consultaVacantes);

  const { get_registro, get_FechaPostulacion, sistemaINE, sistemaOPLE } =
    useSelector((state) => state.sistemas);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(obtenerSistemaINE());
    dispatch(obtenerSistemaOPLE());
  }, [dispatch]);

  const validaFecha = () => {
    if (get_FechaPostulacion !== null && get_FechaPostulacion !== undefined) {
      const { fechaInicio, fechaFin } = get_FechaPostulacion;
      const hoy = new Date(moment().format(DATE_FORMAT_EXP));
      const startDate = new Date(moment(fechaInicio).format(DATE_FORMAT_EXP));
      const endDate = new Date(moment(fechaFin).format(DATE_FORMAT_EXP));
      //Si la fecha actual es menor a la fecha inicio se bloquea el botón
      if (hoy < startDate) return true;
      //Si la fecha actual es igual o mayor a la fecha inicio y no existe fecha fin se habilita el botón
      if (hoy >= startDate && isNaN(endDate.getTime())) {
        return false;
      }
      //Si la fecha actual se encuentra en el rango de las fechas inicio y fin se habilita el botón
      //Si ya pasaron las fechas y el estatus se encuentra en 1, solo se bloquea el botón
      return hoy >= startDate && hoy <= endDate ? false : true;
    }
  };

  return (
    <>
      <div className="layout-content-public mainHeaderVacantes">
        {!autenticado && (
          <div className="alert-info" style={{ fontSize: "20px" }}>
            <InfoCircleFilled
              style={{ fontSize: "20px", color: "blueviolet" }}
            />{" "}
            <span style={{ fontWeight: 700 }}>
              {`Para postularte es necesario `}
            </span>
            <span>{`iniciar sesión `}</span>
            {get_registro !== null &&
            get_registro !== undefined &&
            get_registro.valorConfiguracion === "1" ? (
              <span hidden={validaFecha()}>
                {`o `}
                <Link
                  to={linksRouter.registro}
                  type="link"
                  style={{ fontSize: "20px", fontWeight: 400 }}
                >
                  <u>{`registrarte`}</u>
                </Link>
              </span>
            ) : (
              <span></span>
            )}
          </div>
        )}
        <Row style={{ textAlign: "center" }}>
          <Col className="HeaderVacantesTitle">
            {idSistema === 1 ? (
              <div>{sistemaINE?.nombreConvocatoria}</div>
            ) : (
              <div>{sistemaOPLE?.nombreConvocatoria}</div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};
